import React, { Component } from 'react';
import './../css/master.css';
import './../css/wvrPendingChanges.css';
import Header from './../js/header.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import WeaverHeader from './../js/weaverHeader.js';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL = '';
var queryString = require('querystring');
var lstWvrPendingChanges = [];
var sortVal = "";
var pendingCbx = "";


class wvrPendingChanges extends Component {
    constructor(props) {
        super(props);
        this.state = {
    
            designNoColor: [],
            flg: true,
            //flgPODesign : true,
            flgStyle: true,
            deliveryDate: null,
            startDate: new Date(),
            endDate: null,
            minDate: null,
            loader: 'none',
            opacity: 1,
            width: '99%',
            flgAdd: true,
            dispReport: '',
            src: require('./../images/blank.png'),
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
    }
    handleChange(date) {
        this.setState({
            startDate: date,
        });
    }
    handleChange1(date) {
        this.setState({
            endDate: date
        });
    }
    
 componentDidMount() {
        this.setState({ loader: 'block', opacity: 0.5 });
        this.handleResize();
        window.addEventListener("load", this.handleResize);
        window.addEventListener("resize", this.handleResize);
        axiosInstance.post(httpURL+'/w/po/pendingchanges/list', 
        ).then((response)=>{	
        	if(response.data.SvcStatus === "Success"){
        			lstWvrPendingChanges=response.data.lstWvrPendingChanges;
        			this.setWvrPendingTable();
        	}
        	else{
        		toast.error(response.data.SvcMsg)
        		if(response.data.SvcMsg == 'You are not logged in'){
        			window.location.href = window.WVRURL;
        			return false;
        		}
        	}
        }).catch((e)=>{
        	toast.error("Service failed "+e);
        });
    }

        


    setWvrPendingTable = () => {
        $('#wvrPendingChangesTableBody tr').remove();
        var table = document.getElementById('wvrPendingChangesTable');
        var tbody = document.getElementById('wvrPendingChangesTableBody');
        var filterIpo = $('#ipo').val().trim().toLowerCase();


        for (var i = 0; i < lstWvrPendingChanges.length; i++) {
            var weaverDelDt = lstWvrPendingChanges[i].weaverDeliveryDt;
            var ipoNo = lstWvrPendingChanges[i].ipoNo;
            var quality = lstWvrPendingChanges[i].quality;
            var designNoColor = lstWvrPendingChanges[i].designNoColor;
            var deskloomDt = lstWvrPendingChanges[i].deskloomDt;
            var newProgress1 = lstWvrPendingChanges[i].newProgress1;
            var newProgress2 = lstWvrPendingChanges[i].newProgress2;
            var newProgress3 = lstWvrPendingChanges[i].newProgress3;
            var newProgressSubmitDtTm = lstWvrPendingChanges[i].newProgressSubmitDtTm;
            var yardageDt = lstWvrPendingChanges[i].yardageDt;
            var oldProgress1 = lstWvrPendingChanges[i].oldProgress1;
            var oldProgress2 = lstWvrPendingChanges[i].oldProgress2;
            var oldProgress3 = lstWvrPendingChanges[i].oldProgress3;
            var oldProgressSubmitDtTm = lstWvrPendingChanges[i].oldProgressSubmitDtTm;
            var rejectedOn = lstWvrPendingChanges[i].rejectedOn;


            var row = document.createElement('tr');
            if (ipoNo.toLowerCase().indexOf(filterIpo) === -1)
                continue;

            this.addTD(row, ipoNo, 'text-left');
            this.addTD(row, weaverDelDt, 'text-center');
            this.addTD(row , designNoColor , 'text-center');
            this.addTD(row, deskloomDt, 'text-center');
            this.addTD(row, yardageDt, 'text-center');
            this.addTD(row, rejectedOn, 'text-center');
            this.addTD(row, oldProgressSubmitDtTm, 'text-center');
            this.addTD(row, oldProgress1, 'text-center');
            this.addTD(row, oldProgress2, 'text-center');
            this.addTD(row, oldProgress3, 'text-center');
            this.addTD(row, newProgressSubmitDtTm, 'text-center');
            if(oldProgress1 != newProgress1)
            {
                this.addTD(row, newProgress1, 'text-center changes');
            }
            else
            {
                this.addTD(row, newProgress1, 'text-center ');
            }
            if(oldProgress2 != newProgress2)
            {
                this.addTD(row, newProgress2, 'text-center changes');
            }
            else
            {
                this.addTD(row, newProgress2, 'text-center ');
            } 
            if(oldProgress3 != newProgress3)
            {
                this.addTD(row, newProgress3, 'text-center changes');
            }
            else
            {
                this.addTD(row, newProgress3, 'text-center ');
            }  
          
    
            $(row).find("td").attr({ width: "100" });
            tbody.append(row);
        }
        table.append(tbody);
    }

    addTD(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        if (val == '-') {
            cell.style.textAlign = 'center';
        }
        var text = document.createTextNode(val);
        cell.append(text);
        row.append(cell);
    }

    handleResize = () => {
        var width = ($('.tableHeadReportDiv').parent().width()) - 18;
        this.setState({ width: width })
    }
    

    sortAscByPo = () => {
        if (sortVal != 'aspo') {
            sortVal = 'aspo';
            $("#poAsDtIcon").css("color", "white");
            $("#poDsDtIcon").css("color", "#f1f1f1");
            $("#deliveryAsDtIcon").css("color", "#f1f1f1");
            $("#deliveryDsDtIcon").css("color", "#f1f1f1");

            var val1;
            var val2;

            for (var i = 0; i < lstWvrPendingChanges.length - 1; i++) {
                val1 = lstWvrPendingChanges[i].ipoNo;
                for (var j = i + 1; j < lstWvrPendingChanges.length; j++) {
                    val2 = lstWvrPendingChanges[j].ipoNo;
                    if (val1 > val2) {
                        var tmp = lstWvrPendingChanges[j];
                        lstWvrPendingChanges[j] = lstWvrPendingChanges[i];
                        lstWvrPendingChanges[i] = tmp;
                        val1 = lstWvrPendingChanges[i].ipoNo;
                    }
                }
            }
            this.setWvrPendingTable();
        }
    }


    render() {
        httpURL = window.httpURL;
        return (
            <div style={{ height: '100%' }}>
                <WeaverHeader />
                <ToastContainer autoClose={2000} hideProgressBar />
                <div className="main">
                    <div className="container-fluid">
                        <div className="col-sm-12 padding-remove" style={{ overflowX: 'hidden' }}>
                            <div className="tablePendingChangesDiv" style={{ width: this.state.width }}>
                                <table id="tableWorkReport" className="tableLayout1">
                                    <thead>
                                        <tr>
                                        <th style={{ width: 40 }}>
                                                <div style={{ float: 'left', width: '80%' }}>
                                                    <input type="text" onChange={this.setWvrPendingTable} className="form-control inp-search" id="ipo" placeholder="IPO" />
                                                </div>
                                                <div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
                                                    <div className="assending">
                                                        <span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
                                                    </div>
                                                    <div className="desending">
                                                        <span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
                                                    </div>
                                                </div>
                                            </th>
                                            <th style={{ width: 40 }}>Weaver <br/> Del.Dt.</th>
                                            <th style={{ width: 60 }}>DesignNoColor</th>
                                            <th style={{ width: 60 }}>Deskloom <br /> Date</th>
                                            <th style={{ width: 50 }}>PP Yardage<br /> Date</th>
                                            <th style={{ width: 50 }}>Rejected<br /> Date</th>
                        
                                            {/* <th style={{ width: 88, backgroundColor: "black", color: 'white' }}>Balance</th> */}
                                            <th className="balanceCol" style={{ width: 100 }}>
                                                <div className="balanceWrap1">Old Status </div>
                                                <div className="balanceWrap">
                                                    <span className=" loom text-center onLoomSub onLoom"> Submit <br/>Date/Time</span>
                                                    <span className=" loom text-center onLoom"> 25%</span>
                                                    <span className=" loom text-center onLoom"> 50%</span>
                                                    <span className=" loom text-center">100%</span>
                                                 </div>
                                            </th>
                                            <th className="balanceCol" style={{ width: 101 }}>
                                                <div className="balanceWrap1">New Status </div>
                                                <div className="balanceWrap">
                                                <span className=" loom text-center onLoomSub onLoom"> Submit <br/>Date/Time</span>
                                                <span className=" loom text-center onLoom"> 25%</span>
                                                    <span className=" loom text-center onLoom"> 50%</span>
                                                    <span className=" loom text-center">100%</span>
                                                 </div>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="workSummaryTableDiv" onScroll={this.theadScroll}>
                                <div style={{width:'100%'}} >
                                    <table id="wvrPendingChangesTable" className="tableLayout">
                                        <colgroup>
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="60" />
                                            <col width="60" />
                                            <col width="50" />
                                            <col width="50" />
                                            <col width="40" />
                                            <col width="20" />
                                            <col width="20" />
                                            <col width="20" />
                                            <col width="40" />
                                            <col width="20" />
                                            <col width="20" />
                                            <col width="20" />
                                        </colgroup>
                                        <tbody id="wvrPendingChangesTableBody"></tbody>
                                    </table>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default wvrPendingChanges;
